import {
    GET_REGISTER,
    PROVINCE_LIST,
    SHIPTO_CITY_LIST,
    BILLTO_CITY_LIST,
    EMAIL_VALID_REGISTER
} from "Actions/register";

const initialState = {

};
let payload = {}

export function register(state = initialState, action) {
    switch (action.type) {
        case GET_REGISTER:
            payload = action.payload

            return Object.assign({}, state, { registerUser: payload});
        case PROVINCE_LIST:
            payload = action.payload

            return Object.assign({}, state, { provinceList: payload });
        case SHIPTO_CITY_LIST:
            payload = action.payload

            return Object.assign({}, state, { shipToCityList: payload });
        case BILLTO_CITY_LIST:
            payload = action.payload

            return Object.assign({}, state, { billToCityList: payload });
        case EMAIL_VALID_REGISTER:
            payload = action.payload

            return Object.assign({}, state, { emailValidRegister: payload});
        default:
            return state;
    }
}
